module.exports = __webpack_public_path__ + "img/shIcon.3d5402ab.png";